import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog is certified as SOC 2 Type II compliant, following an external audit. `}</p>
    <p>{`Our latest `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1gZNorQK3Pq9KqNvUWXMNJsdQpUwxzKNe/view?usp=sharing"
      }}>{`security report`}</a>{` is publicly available (covering controls as of May 31st, 2025). `}</p>
    <h3 {...{
      "id": "policies"
    }}>{`Policies`}</h3>
    <p>{`We have a number of policies in place to support SOC 2 compliance. All team members have been invited to Drata to review these and to complete security training and background checks as part of onboarding.`}</p>
    <p>{`All of these policies are available for viewing `}<a parentName="p" {...{
        "href": "/talk-to-a-human"
      }}>{`upon request`}</a>{`:`}</p>
    <ul>
      <li parentName="ul">{`Acceptable Use Policy`}</li>
      <li parentName="ul">{`Application Logging & Monitoring Policy`}</li>
      <li parentName="ul">{`Asset Management Policy`}</li>
      <li parentName="ul">{`Backup Policy`}</li>
      <li parentName="ul">{`Breach Notification Policy`}</li>
      <li parentName="ul">{`Business Associate Policy`}</li>
      <li parentName="ul">{`Business Continuity Plan`}</li>
      <li parentName="ul">{`Code of Conduct`}</li>
      <li parentName="ul">{`Data Classification Policy`}</li>
      <li parentName="ul">{`Data Deletion Policy`}</li>
      <li parentName="ul">{`Data Protection Policy`}</li>
      <li parentName="ul">{`Disaster Recovery Plan`}</li>
      <li parentName="ul">{`Encryption Policy`}</li>
      <li parentName="ul">{`Incident Response Plan`}</li>
      <li parentName="ul">{`Information Security Policy`}</li>
      <li parentName="ul">{`Password Policy`}</li>
      <li parentName="ul">{`Physical Security Policy`}</li>
      <li parentName="ul">{`Privacy, Use, and Disclosure Policy`}</li>
      <li parentName="ul">{`Responsible Disclosure Policy`}</li>
      <li parentName="ul">{`Risk Assessment Policy`}</li>
      <li parentName="ul">{`Software Development Lifecycle Policy`}</li>
      <li parentName="ul">{`System Access Control Policy`}</li>
      <li parentName="ul">{`Vendor Management Policy`}</li>
      <li parentName="ul">{`Vulnerability Management Policy`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      